export default __webpack_public_path__ + "static/media/icon-ic-google.24db08aa.svg";